import { useDataModel } from '@thd-nucleus/data-sources';
import {
  ANCHOR_TYPE,
  APPLICATION,
  CUSTOMER_TYPE,
  PAGE_TYPE
} from '../data-model/constants';

/**
 * Requests the suggested questions and summary for a search term.
 *
 * `fetchPolicy` is set explicitly because the banner renders inside a provider that declares a
 * `dataSource`, which would otherwise default the query to `cache-only` and leave it unable to
 * fetch on the client. Matches how category-cards requests `getContent`.
 *
 * @param {object} params
 * @param {string} params.anchor - Search term to request for; an empty value skips the request.
 * @param {string} params.customerType - Customer type to request for, in any casing; the banner is
 * B2C-only, so an absent or non-B2C type skips the request.
 * @param {boolean} [params.ssr=true] - Whether to resolve the query during server render.
 * @returns {{ data: object, loading: boolean, error: object }} Query state.
 */
export const useSuggestedQuestions = ({ anchor, customerType, ssr = true } = {}) => {
  const requestedCustomerType = customerType?.toUpperCase();
  const skip = !anchor || requestedCustomerType !== CUSTOMER_TYPE.B2C;

  return useDataModel(
    'suggestedQuestions',
    {
      variables: {
        request: {
          application: APPLICATION.PLP_BANNER,
          pageType: PAGE_TYPE.PLP,
          customerType: requestedCustomerType,
          anchors: [{ type: ANCHOR_TYPE.SEARCH_TERM, value: anchor }]
        }
      },
      ssr,
      skip,
      fetchPolicy: 'cache-first'
    }
  );
};
